// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjConfiguration  {
    _originalTypeClassName = "Loom.BO.ProjConfiguration";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjConfiguration.translate = translateService;
}
this.Id = null;
this.Step = null;
this.MinHours = null;
this.IsMinHoursRequired = false;
this.MaxAllowedYearlyManHours = null;
this.LimitClaimAmountForAuditCertificate = null;
this.InternalFinancialReportingIntervalInMonths = null;
this.PersonnelEffortDeviationPercentageLimit = 0.1;
this.PersonnelCostsDeviationPercentageLimit = 0.1;
this.PMRateDeviationPercentageLimit = 0.1;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Step:any;
MinHours:any;
IsMinHoursRequired:any;
MaxAllowedYearlyManHours:any;
LimitClaimAmountForAuditCertificate:any;
InternalFinancialReportingIntervalInMonths:any;
PersonnelEffortDeviationPercentageLimit:any;
PersonnelCostsDeviationPercentageLimit:any;
PMRateDeviationPercentageLimit:any;
Project:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
if (oldValue != null && oldValue.ProjConfiguration != null) { oldValue.ProjConfiguration = null; }
if ($this.Project.ProjConfiguration !== $this) {
Domain.Project.setProjConfiguration(value, $this);
}
}
}

static GetDefault(): any{let def = new Domain.ProjConfiguration();
def = new Domain.ProjConfiguration();
def.Step = 1;
def.MinHours = 1;
def.IsMinHoursRequired = false;
return def;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}